import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IAnswerSurveyForAgentClient,
} from 'interfaceAdapter/gatewaySchemas/IAnswerSurveyForAgentClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/agent/answer_survey`;

export class AnswerSurveyForAgentClient implements IAnswerSurveyForAgentClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, matchId, answers } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-A': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({
            match_id: matchId,
            answers: answers,
        });

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
